<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1379246" style="color: #82a339"><b>BUFFALO-STYLE CHICKEN WINGS</b></p>
<p class="ext" id="d7e1379746"><b><i>Here’s a broiled version of one of America’s favorite appetizers. Serve with plenty of napkins!</i></b></p>
<p class="h4" id="d7e1380746" style="color: #496210"><b>Prep: 15 minutes     Broil: 20 minutes</b></p>
<p class="ul" id="d7e1381346">4 ounces blue cheese, crumbled (1 cup)</p>
<p class="ul" id="d7e1381646">½ cup sour cream</p>
<p class="ul" id="d7e1382546">¼ cup mayonnaise</p>
<p class="ul" id="d7e1383546">¼ cup milk</p>
<p class="ul" id="d7e1384446">¼ cup chopped fresh parsley</p>
<p class="ul" id="d7e1385446">1 tablespoon fresh lemon juice</p>
<p class="ul" id="d7e1385746">½ teaspoon salt</p>
<p class="ul" id="d7e1386646">3 pounds chicken wings (18 wings), tips discarded, <br/> if desired</p>
<p class="ul" id="d7e1387346">3 tablespoons butter or margarine</p>
<p class="ul" id="d7e1387646">¼ cup hot pepper sauce</p>
<p class="ul" id="d7e1388546">1 medium bunch celery, cut into sticks</p>
<p class="pub" id="d7e1389046" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Preheat broiler. In medium bowl, combine blue cheese, sour cream, mayonnaise, milk, parsley, lemon juice, and ¼ teaspoon salt. Cover and refrigerate.</p>
<p class="pub" id="d7e1391246"><span style="color: #c15b49"><b>2.</b></span> Arrange chicken wings on rack in broiling pan; sprinkle with remaining ¼ teaspoon salt. Broil 5 inches from heat source 10 minutes. Turn wings and broil until golden, 10 to 15 minutes longer.</p>
<p class="pub" id="d7e1393746"><span style="color: #c15b49"><b>3.</b></span> Meanwhile, in small saucepan, melt butter with hot pepper sauce over low heat, stirring occasionally; keep hot.</p>
<p class="pub" id="d7e1395146"><span style="color: #c15b49"><b>4.</b></span> In large bowl, toss wings with seasoned butter to coat all sides. Arrange chicken wings and celery on platter along with blue-cheese sauce and serve. Makes 18 appetizers.</p>
<p class="ntx" id="d7e1397046">Each appetizer (without wing tip) : About 169 calories, 10g protein, 3g carbohydrate, 13g total fat (5g saturated), 39mg cholesterol, 349mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c38_r1.vue?417427ce